var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"breadcrumbs"},[_c('a',{on:{"click":function($event){return _vm.goBack()}}},[_c('div',{staticClass:"icon-back"})])])}
var staticRenderFns = []

export { render, staticRenderFns }